// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Icon from '@atlaskit/icon';
import Tooltip from '@atlaskit/tooltip';
import type { Props } from './types';

export const HIDE_ICON = 'hide-icon';
export const SHOW_ICON = 'show-icon';

const hideIcon = (props: ComponentProps<'svg'>) => (
	<svg {...props} viewBox="0 0 24 24">
		<g transform="translate(3 3)" fill="currentColor" fillRule="evenodd">
			<path
				d="M2 11v5h14v-5H2zM0 1.995C0 .893.893 0 1.995 0h14.01C17.107 0 18 .893 18 1.995v14.01A1.995 1.995 0 0 1 16.005 18H1.995A1.995 1.995 0 0 1 0 16.005V1.995z"
				fillRule="nonzero"
			/>
			<rect x="3" y="12" width="8" height="2" rx="1" />
			<rect x="13" y="12" width="2" height="2" rx="1" />
		</g>
	</svg>
);

const showIcon = (props: ComponentProps<'svg'>) => (
	<svg {...props} viewBox="0 0 24 24">
		<g transform="translate(3 3)" fill="currentColor" fillRule="evenodd">
			<path
				d="M2 11v5h14v-5H2zm0-1V9h14v1-8H2v8zM0 1.995C0 .893.893 0 1.995 0h14.01C17.107 0 18 .893 18 1.995v14.01A1.995 1.995 0 0 1 16.005 18H1.995A1.995 1.995 0 0 1 0 16.005V1.995z"
				fillRule="nonzero"
			/>
			<rect x="3" y="12" width="8" height="2" rx="1" />
			<rect x="13" y="12" width="2" height="2" rx="1" />
		</g>
	</svg>
);

const CardCoverIcon = ({ icon, label }: Props) => {
	const iconGlyph = icon === SHOW_ICON ? showIcon : hideIcon;

	return (
		<Tooltip position="top" content={label}>
			<Icon glyph={iconGlyph} label={label} size="small" />
		</Tooltip>
	);
};

export default CardCoverIcon;
